import axios from 'axios'
import { EMBARCAR_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function embarcarEncomenda (idEmpresa, idEncomenda) {
  const url = `${URL}/encomendas/empresa/${idEmpresa}/encomenda/${idEncomenda}/embarcar-encomenda`;
  return dispatch => axios.post(url,null , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EMBARCAR_ENCOMENDA,
        payload: response
      })
  );
}